<template>
  <div class="checkbox-container">
    <select :name="question.uid" v-on:change="handleSelect" class="form-control">
      <option>{{ $t("ui.selectOption") }}</option>
      <option v-for="model in question.answers"
              v-bind:key="model.uid" style="line-height: 1;"
              v-html="model.title" :value="model.uid">
      </option>

      <br>
      <br>

      <transition name="fade">
        <comment v-show="showComment" :placeholder="commentPlaceholder" :name="commentName"></comment>
      </transition>

    </select>

    <input type="hidden" class="answerSelected" data-question="question.uid" v-model="answerSelected">
  </div>
</template>

<script>
import Vue from 'vue';
import Comment from './Comment';

export default {
  name: 'selectOne',
  props: ['question'],
  data() {
    return {
      answerSelected: false,
      showComment: false,
      commentPlaceholder: false,
      commentName: false
    }
  },
  methods: {
    handleSelect: function (e) {

      const uid = e.target.value;

      this.showComment = false;
      this.commentPlaceholder = false;
      this.commentName = false;

      this.$emit("inputClick", uid);

      this.question.answers.forEach((item, index) => {
        if (item.uid === uid) {
          item.selected = true;

          // TODO: Fix comments

          if (item.is_allow_comment) {
            this.showComment = true;
            this.commentPlaceholder = item.comment_placeholder;
            this.commentName = 'comment_' + this.question.uid;
          }
          Vue.set(this.question.answers, index, item);
        } else {
          item.selected = false;
          Vue.set(this.question.answers, index, item);
        }

        this.$emit("checkDependency", uid);
      });
    }
  },
  components: {
    Comment
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .10s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}
</style>
